'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Round number to a given precision
 * Default precision is 3
 *
 * @param num number
 * @param precision number
 * @returns number
 */ const roundNumber = (num, precision = 3)=>{
    return Math.round(num * 10 ** precision) / 10 ** precision;
};
/**
 * Get if two numbers closely match to each other. If they do, return the first number.
 * Threshold is 0.001 by default.
 *
 * @param scale number
 * @param nextScale number
 * @param threshold number
 * @returns number | undefined
 */ const getNumberCloselyMatches = (num, match, threshold = 0.001)=>{
    const precision = threshold.toString().split('.')[1].length || 0;
    const abs = roundNumber(Math.abs(num - match), precision);
    return abs > threshold ? undefined : num;
};
/**
 * Create an number range array
 *
 * @param options GetNumberRangeOptions
 * @returns number[]
 */ const getNumberRange = ({ increment , length , operator , start  })=>[
        ...Array.from({
            length
        }).keys()
    ].map((i)=>i === 0 ? start : operator === '+' ? start + i * increment : start - i * increment);

exports.getNumberCloselyMatches = getNumberCloselyMatches;
exports.getNumberRange = getNumberRange;
exports.roundNumber = roundNumber;
//# sourceMappingURL=number.js.map
